"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ConsoleProvider {
    identify(identity) {
        console.log('[Analytics] identify', identity);
    }
    updateIdentity(data) {
        console.log('[Analytics] updateIdentity', data);
    }
    trackEvent(eventName, category, properties) {
        console.log('[Analytics] trackEvent', eventName, category, properties);
    }
    logout() {
        console.log('[Analytics] logout');
    }
    trackPage() {
        console.log('[Analytics] trackPage');
    }
}
exports.default = ConsoleProvider;
